/**
 * The Ed25519 public key registry for release manifest signatures, keyed by
 * `keyId` (see `sign.ts`'s `deriveKeyId`). Pure data, no `node:*` import, so
 * both `publish.ts` and the Cloudflare Worker serving the `latest` redirect
 * read the same source of truth.
 *
 * This file is the PRIVATE-repo copy. `publish.ts` mirrors it verbatim into
 * `public-keys.json` at the root of the public `gibsfinance/interface-releases`
 * repository on every publish, so the Worker — which cannot read this
 * private repository — always has an up-to-date copy to verify against. See
 * `docs/ipfs-releases.md` for the full contract.
 *
 * Adding a key: run `scripts/ipfs-release/generate-key.ts`, then add the
 * printed `keyId` and `publicKeyBase64` here and commit. Never remove a
 * retired key while any `releases[]` entry it signed is still reachable —
 * removing it early breaks verification of that release's manifest history.
 */

export type PublicKeyEntry = {
  publicKeyBase64: string;
  algorithm: 'Ed25519';
  createdAt: string; // ISO 8601, the date `generate-key.ts` produced this key
};

export const PUBLIC_KEYS: Record<string, PublicKeyEntry> = {
  '156714f0e2a97dfb': {
    publicKeyBase64: 'HYprj/nGvLwJoGMBxRTgHp+SBMWcyrrx6xm3/1WPW38=',
    algorithm: 'Ed25519',
    createdAt: '2026-09-24T00:57:24.227Z',
  },
};
